export const floatingVueOptions = { themes: { tooltip: { html: true, triggers: ['hover', 'touch'] } } };
